export default __webpack_public_path__ + "static/media/ftx-token-ftt-logo.c0096fca.svg";